import React, { Fragment } from 'react';
import useMedia from 'hooks/useMedia';
import {
  ColumnWrapper,
  Container,
  H2,
  LeftDataSection,
  Loader,
  RightDataSection,
} from './shared/styles';
import times from 'lodash.times';

interface ISystemDataSectionSkeletonLoaderProps {
  sectionLabel: string;
}

const SystemDataSectionSkeletonLoader: React.FC<ISystemDataSectionSkeletonLoaderProps> = (
  props
) => {
  const { sectionLabel } = props;

  const isMobileView = useMedia('(max-width: 40em)');

  return (
    <Container isMobileView={isMobileView} data-pw="status-dsp-data-loader">
      <ColumnWrapper isMobileView={isMobileView} mt={4} pb={3}>
        <LeftDataSection>
          <H2>{sectionLabel}</H2>
          <Loader width={300} height={150} uniquekey="loader">
            {times(3, (idx) => (
              <Fragment key={`event-skeleton-${idx}`}>
                <rect width="300" height="25" y={20 + 40 * idx} />
              </Fragment>
            ))}
          </Loader>
        </LeftDataSection>
        <RightDataSection>
          <Loader width={400} height={250} uniquekey="loader-table">
            {times(5, (idx) => (
              <Fragment key={`event-skeleton-${idx}`}>
                <rect width="300" height="25" y={0 + 38 * idx} />
              </Fragment>
            ))}
          </Loader>
        </RightDataSection>
      </ColumnWrapper>
    </Container>
  );
};

export default SystemDataSectionSkeletonLoader;
